import { render, staticRenderFns } from "./PartyRestrictions.vue?vue&type=template&id=35e65885"
import script from "./PartyRestrictions.vue?vue&type=script&lang=js"
export * from "./PartyRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports